"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorToolTip = void 0;
var _styles = require("@material-ui/core/styles");
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ErrorToolTip = exports.ErrorToolTip = (0, _styles.withStyles)(function () {
  return {
    tooltip: {
      backgroundColor: '#F8D7DA',
      color: '#721C24',
      display: 'flex',
      alignItems: 'center'
    },
    arrow: {
      color: "#F8D7DA"
    }
  };
})(_Tooltip["default"]);
//# sourceMappingURL=errorToolTip.js.map